export default __webpack_public_path__ + "static/media/garanty.cea3388b.svg";